<template>
  <div class="intangibleLevel-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           :title="title"
           @on-ok="createintangibleLevel('intangibleLevelValidate')"
           :loading="loading">
      <Form :model="intangibleLevel"
            ref="intangibleLevelValidate"
            :rules="intangibleLevelValidate"
            action="javascript:void(0)">
        <FormItem label="分类名称"
                  prop="title">
          <Input v-model="intangibleLevel.title"
                 placeholder="输入分类名称..."></Input>
        </FormItem>
        <FormItem label="类型"
                  prop="type_id">
          <Select v-model="intangibleLevel.type_id"
                  filterable
                  placeholder="类型">
            <Option v-for="item in typeList"
                    :value="item.type_id"
                    :key="item.type_id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'intangibleLevel-list',
  data () {
    return {
      loading: true,
      dataloading: true,
      thumblist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
      },
      bigDisplay: '',
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '名称',
          key: 'title',
          minWidth: 200
        },
        {
          title: '类型',
          key: 'typename',
          minWidth: 200,
          //   render: (h, params) => {
          //     var par = params.row.type_id;
          //     var sname = '';
          //     for (var i = 0; i < this.typeList.length; i++) {
          //       if (par == this.typeList[i].type_id) {
          //         sname = this.typeList[i].name;
          //         break;
          //       }
          //     }
          //     return h('div', [
          //       h('span', {
          //       }, sname)
          //     ]);
          //   }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      intangibleLevel: {
        title: '',
        status: true,
      },
      showModalStatus: false,
      intangibleLevelValidate: {
        title: [
          { required: true, message: '名称必须填写', trigger: 'blur' }
        ]
      },
      typeList: [],
    }
  },
  created: function () {
    // 取数据
    this.getTableList();
    this.getTypeList();
  },
  methods: {
    getTableList: function () {
      this.$api.intangibleLevel.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getTypeList () {
      this.$api.intangibleLevel.type().then(res => {
        if (res.code == 200) {
          this.typeList = res.result;
          console.log(res);
        }
      });
    },
    // 展开添加
    showModel () {
      this.title = "添加";
      this.intangibleLevel = {
        name: '',
        type_id: 0,
      };
      this.thumblist = new Array();
      this.$refs['intangibleLevelValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index, id) {
      this.title = "编辑分类";
      this.intangibleLevel = {
        title: '',
        type_id: 0,
      };
      this.thumblist = new Array();
      this.$refs['intangibleLevelValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.$api.intangibleLevel.detail({ id: id }).then(res => {
        this.intangibleLevel = res.result;
      });
    },
    // 添加
    createintangibleLevel (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.intangibleLevel.id == null || this.intangibleLevel.id == 0) {
            this.$api.intangibleLevel.create(this.intangibleLevel).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => { this.loading = true; });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.intangibleLevel.edit(this.intangibleLevel).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => { this.loading = true; });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.intangibleLevel.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.tablelist.splice(index, 1);
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.intangibleLevel.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = { 'key': this.formItem.key, "page": this.pages.page, "size": this.pages.size };
      this.$api.intangibleLevel.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  },
}
</script>
